import Link from '@mui/material/Link'

const siteData = {
  bannerHeader: <>Hi! I'm Vincent.</>,
  bannerBody1: (
    <>
      I'm a senior at the University of Washington majoring in Computer Science, and a Research
      Scientist at the{' '}
      <Link href="https://www.beliveau.io" target="_blank" rel="noopener noreferrer">
        Beliveau Lab
      </Link>
      .
    </>
  ),
  bannerStatus: <>Rust!!! 🦀🦀🦀</>,
}

export default siteData
